import { Data as JsonData } from "./Data";
import { Typed as JsonTyped } from "./Typed";
import { Untyped as JsonUntyped } from "./Untyped";
export var Json;
(function (Json) {
    Json.Data = JsonData;
    function create(type, options) {
        return type && "is" in type ? new JsonTyped(type, options) : new JsonUntyped(type);
    }
    Json.create = create;
    let parser;
    function parse(data) {
        return (parser ??= create()).parse(data);
    }
    Json.parse = parse;
    function stringify(data) {
        return (parser ??= create()).stringify(data);
    }
    Json.stringify = stringify;
})(Json || (Json = {}));
//# sourceMappingURL=index.js.map